import { VerificationFailedContinueToIDContainer } from 'src/containers';

export const VerificationFailedContinueToID = () => <VerificationFailedContinueToIDContainer />;
